import { TextareaHTMLAttributes, forwardRef } from 'react';

import { useFieldContext } from '@reckon-web/field';
import {
  InputSizeType,
  InputWeightType,
  useInputStyles,
} from '@reckon-web/text-input';

type NativeElementProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export type TextareaProps = {
  size?: InputSizeType;
  onChange: NonNullable<NativeElementProps['onChange']>;
  value: NonNullable<NativeElementProps['value']>;
  weight?: InputWeightType;
} & Omit<NativeElementProps, 'onChange' | 'type' | 'size' | 'value'>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ size = 'medium', weight = 'subtle', ...textareaProps }, ref) => {
    const styles = useInputStyles({ size, shape: 'square', weight });
    const { invalid, ...a11yProps } = useFieldContext();

    return (
      <textarea
        aria-invalid={invalid}
        ref={ref}
        css={styles}
        rows={4}
        {...a11yProps}
        {...textareaProps}
      />
    );
  }
);
